module.exports = {"OTP_SECRET_KEY":"","OTP_ALGORITHM":"SHA1","OTP_DIGITS":6,"OTP_PERIOD":30}